import { CryptoCurrencyId, CryptoCurrencyStatistics } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { COIN_ID_BITCOIN } from 'fixtures/crypto/currencies'

export const CRYPTO_REWARDS_PANE_DEFAULTS_CURRENCY_STATISTICS: Omit<CryptoCurrencyStatistics, 'id'> = {
  marketCapUSD: 0,
  changePercent: 0,
  price: '0',
}

export const CRYPTO_REWARDS_PANE_GENERAL_UNKNOWN_RESPONSE_ERROR = { non_field_errors: ['An unknown error'] }

export const DEFAULT_CRYPTO_CURRENCY_ID_FOR_INVESTMENT = COIN_ID_BITCOIN as CryptoCurrencyId
